<template>
  <div class="wrapper">
    <app-page title= 'Заявка'>
      <p> <strong>ФИО:</strong> {{ name }}</p>
      <p> <strong>Телефон:</strong> {{ phone }}</p>
      <p> <strong>Номер договора:</strong> {{ contract }}</p>
      <p> <strong>Комментарий:</strong> {{ message }}</p>

      <button class="btn danger" @click="remove">Удалить</button>
      <button class="btn warning" @click="back">Назад</button>
    </app-page>
  </div>
</template>

<script>
import AppPage from "@/components/backend/AppPage";
import {useRoute, useRouter} from 'vue-router';
import {ref, onMounted, reactive} from 'vue'
import {useStore} from "vuex";

export default {
  setup() {
    const route = useRoute()
    const router = useRouter()
    const store = useStore()
    const request = reactive({})

    const name = ref()
    const phone = ref()
    const contract = ref()
    const message = ref()
    const id = ref()

    onMounted( () => {
      request.value = store._state.data.request.requests
      .filter(request => {
        if (request._id === route.params.id) {
          return request
        }
      })
      name.value = request.value[0].name
      phone.value = request.value[0].phone
      contract.value = request.value[0].contract
      message.value = request.value[0].message
      id.value = route.params.id
    })

    const remove = async () => {
      await store.dispatch('request/removeRequest', id)
      await router.push('/admin')
      await store.dispatch('request/getRequests', null, {root: true})
    }

    const back = () => {
      router.go(-1)
    }

    return {
      request,
      name,
      phone,
      contract,
      message,
      id,
      remove,
      back
    }
  },
  components: {AppPage}

}
</script>

<style scoped>

.wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

</style>